import React, {
	useState,
	useRef,
	ChangeEvent,
	KeyboardEvent,
	MouseEvent,
	useEffect,
} from 'react';
import { useParams } from 'react-router-dom';

import { PlatformCode } from 'type/common';

import { usePutCreatorMemo } from 'hooks/queries/creator';
import useGetSearchParams from 'hooks/useGetSearchParams';
import CoreInput from 'shared/input/CoreInput';
import { EllipsisText } from 'styles/styled-components/report';
import style from 'styles/styled-components/style';
import {
	platform_EN_name_mapper,
	platform_EN_to_code_mapper,
} from 'utils/platformMapper';

interface MemoCellProps {
	initialMemo: string;
	recommendationId?: string;
	creatorPk?: string;
	platform?: string;
}

const MemoCell = ({
	initialMemo,
	recommendationId,
	creatorPk,
	platform,
}: MemoCellProps) => {
	const [isEditing, setIsEditing] = useState(false);
	const [memo, setMemo] = useState('');
	const inputRef = useRef<HTMLInputElement>(null);

	const { mutate: updateMemo } = usePutCreatorMemo(
		recommendationId || '',
		creatorPk?.toString() || '',
		platform || '',
	);

	const handleClick = (e: MouseEvent) => {
		e.stopPropagation();
		if (!recommendationId || !creatorPk) return;
		setIsEditing(true);
		setTimeout(() => inputRef.current?.focus(), 0);
	};

	const handleSave = () => {
		if (!isEditing) return;
		setIsEditing(false);

		if (memo === initialMemo) return;

		if (recommendationId && creatorPk) {
			updateMemo(memo);
		}
	};

	const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
		if (e.key === 'Enter') {
			handleSave();
		}
	};

	useEffect(() => {
		setMemo(initialMemo);
	}, [initialMemo]);

	return (
		<Grid flex="center" _width="100%" _height="100%" _padding="0 16px">
			{isEditing ? (
				<CoreInput
					input_id="memo-input"
					_width="100%"
					_value={memo}
					_onChange={(e: ChangeEvent<HTMLInputElement>) => {
						if (e.target.value.length > 30) return;
						setMemo(e.target.value);
					}}
					_onKeyDown={handleKeyDown}
					_onBlur={handleSave}
					_ref={inputRef}
				/>
			) : (
				<Grid
					flex="center"
					_width="100%"
					_height="100%"
					onClick={handleClick}
					// style={{ cursor: recommendationId && creatorPk ? 'pointer' : 'default' }}
				>
					<EllipsisText
						typo="p_bold"
						style={{
							width: '100%',
							height: '100%',
							display: 'flex',
							alignItems: 'center',
						}}
					>
						{memo || '-'}
					</EllipsisText>
				</Grid>
			)}
		</Grid>
	);
};

const { Grid } = style;

export default MemoCell;
